import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './imagegallery.css';
import { Area1, Area2, Area3, Area4 } from '../../assets/images/images';

const Gallery = () => {
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  // Auto-scroll functionality similar to awards section
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    let scrollInterval;
    let isPaused = false;

    const startScroll = () => {
      scrollInterval = setInterval(() => {
        if (!isPaused) {
          if (slider.slickNext) {
            slider.slickNext();
            setCurrentSlide((prev) => (prev + 1) % 4); // 4 total slides
          }
        }
      }, 3000); // Change slide every 3 seconds
    };

    const pauseScroll = () => {
      isPaused = true;
    };

    const resumeScroll = () => {
      isPaused = false;
    };

    // Add event listeners for pause/resume on hover
    const sliderElement = slider.querySelector('.slick-slider');
    if (sliderElement) {
      sliderElement.addEventListener('mouseenter', pauseScroll);
      sliderElement.addEventListener('mouseleave', resumeScroll);
    }

    startScroll();

    return () => {
      clearInterval(scrollInterval);
      if (sliderElement) {
        sliderElement.removeEventListener('mouseenter', pauseScroll);
        sliderElement.removeEventListener('mouseleave', resumeScroll);
      }
    };
  }, []);

  return ( 
    <div className="gallery-section container margin-auto">
      <h2 className='heading_main'>Gallery</h2>
      <div ref={sliderRef}>
        <Slider {...settings}>
          <div className="gallery-item">
            <img src={Area1} alt="Waiting Area" />
            <div className="gallery-caption">Waiting Area</div>
          </div>
          <div className="gallery-item">
            <img src={Area2} alt="Play Area" />
            <div className="gallery-caption">Play Area</div>
          </div>
          <div className="gallery-item">
            <img src={Area3} alt="Room 1" />
            <div className="gallery-caption">Room 1</div>
          </div>
          <div className="gallery-item">
            <img src={Area4} alt="Room 2" />
            <div className="gallery-caption">Room 2</div>
          </div>
        </Slider>
      </div>
      <div className="view-all-gallery">
        <Link to="/gallery" className="gallery-link">View all gallery</Link>
      </div>
    </div>
  );
};

export default Gallery;
